import NaptimeResource from './NaptimeResource';

class groupForumStatistics extends NaptimeResource {
  static RESOURCE_NAME = 'groupForumStatistics.v1';
}

export default groupForumStatistics;
